import React from "react";
import customImg from "../../common/images/crm_services.png";
import our from "../../common/images/Our.png";
import softwareLogo from "../../common/images/crm-logo.png";
const HeroSection = () => {
  return (
    <section className="max-w-[1280px] mx-auto  px-5 md:px-10 ">
      <div className=" flex flex-col lg:flex-row  small:gap-10 gap-5 relative">
        <div className="img absolute -translate-x-1/2 w-[100px] md:block hidden py-10 z-10 left-[40%]">
          <img src={softwareLogo} alt="" className="w-full" />
        </div>
        <div className="lg:w-1/2 md:py-12 py-5 md:text-center text-start lg:text-left">
          <img src={our} alt="Our Img" className="h-20 w-15" />

          <div className="flex items-center gap-5 ">
            <p className="text-black  uppercase tracking-widest font-semibold">
              Services
            </p>

            <p className="h-[3px] w-[30%] bg-[#FFC400]"></p>
          </div>
          <h1 className="text-2xl xs:text-3xl small:text-4xl lg:text-5xl font-bold text-secondary mt-2">
             <span className="text-[#FFC400]"> CRM </span>Development
          </h1>
          <p className="text-black small:text-md text-sm mt-4 font-semibold  w-full ">
            At <b>Binary Ops Pvt Ltd</b>, we design and
            develop custom <b>Customer Relationship Management (CRM) systems</b> to
            help businesses strengthen customer relationships, streamline
            operations, and boost profitability. Our CRM solutions are tailored
            to your specific business needs, enabling you to manage customer
            interactions, automate workflows, and gain valuable insights — all
            from a single platform
          </p>
          {/* <button className="small:mt-6 mt-3 px-10 py-2 bg-secondary text-white rounded-lg font-semibold small:text-lg text-sm hover:bg-blue-500 transition-all">
            LET’S TALK
          </button> */}
        </div>
        <div className="lg:w-1/2 md:py-10 py-0 bg-gray-50 flex justify-center relative">
          <img
            src={customImg}
            alt="Android Development"
            className="w-full max-w-sm md:max-w-md lg:max-w-lg drop-shadow-lg"
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
